import ErrorService from "@exceptions/ErrorHandler";
import { NoResponseDataError } from "@exceptions/NoResponseDataError";
import RestService from "@lib/RestService";
import store from "@store/store";

function makeRequest(
  method: "POST" | "PUT" | "GET" | "DELETE",
  url: string,
  data?: any,
  pathParams?: { [key: string]: string }
): Promise<any> {
  const tokenData = store.getState().tokenData.tokenData;

  return new Promise<any>((resolve, reject) => {
    let requestUrl = url;
    // Replace path parameters in the URL
    if (pathParams) {
      for (const key in pathParams) {
        requestUrl = requestUrl.replace(`:${key}`, pathParams[key]);
      }
    }

    const restService = new RestService()
      .setUrl(requestUrl)
      .setMethod(method)
      .setHasToken(true)
      .setToken(tokenData)
      .flagReturnData(true);

    if (data && (method === "POST" || method === "PUT")) {
      restService.setPostBody(data);
    }

    restService
      .connect()
      .then((response) => {
        if (!response.data) {
          reject(new NoResponseDataError());
        } else {
          resolve(response);
        }
      })
      .catch((error) => {
        ErrorService.reportError(error);
        reject(error);
      });
  });
}

export function makePostRequest(
  url: string,
  data: any,
  pathParams?: { [key: string]: any }
): Promise<any> {
  return makeRequest("POST", url, data, pathParams);
}

export function makePutRequest(
  url: string,
  data: any,
  pathParams?: { [key: string]: any }
): Promise<any> {
  return makeRequest("PUT", url, data, pathParams);
}

export function makeGetRequest(
  url: string,
  pathParams?: { [key: string]: any }
): Promise<any> {
  return makeRequest("GET", url, undefined, pathParams);
}

export function makeDeleteRequest(
  url: string,
  pathParams?: { [key: string]: any }
): Promise<any> {
  return makeRequest("DELETE", url, undefined, pathParams);
}
